import { gql, useQuery } from '@apollo/client';
import { callSideEffects } from '../../util';
import { FlightLeg } from '../../util/flight/flightLeg';
import { DateFormats } from '../../contracts/types';
export const flightDetailsFragment = gql `
    fragment FlightDetails on TripState {
        tripStateId
        flightsRequest {
            availabilitySearchId
            selectedDestinationAirport {
                airportCode
            }
            flightId
            flightDetailsId
        }
    }
`;
const FLIGHT_FROM_TRIP_QUERY = gql `
    ${flightDetailsFragment}
    query FlightFromTrip(
        $tripStateId: ID!
        $departureDateFormat: DateFormats
        $timeFormat: DateFormats
    ) {
        getFlightFromTrip(tripStateId: $tripStateId) {
            tripState {
                ...FlightDetails
            }
            flight {
                inboundLeg {
                    ${FlightLeg}
                }
                outboundLeg {
                    ${FlightLeg}
                }
            }
        }
    }
`;
export function useFlightFromTrip(tripStateId, skip = false, sideEffects = [], errorSideEffects = []) {
    return useQuery(FLIGHT_FROM_TRIP_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        skip: !tripStateId || skip,
        variables: {
            tripStateId,
            departureDateFormat: DateFormats.Fulldate,
            timeFormat: DateFormats.Time,
        },
        fetchPolicy: 'cache-and-network',
        onCompleted: (data) => {
            if (sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.length) {
                callSideEffects(sideEffects, data);
            }
        },
        onError: (error) => {
            if (errorSideEffects === null || errorSideEffects === void 0 ? void 0 : errorSideEffects.length) {
                callSideEffects(errorSideEffects, error);
            }
        },
    });
}
